//import { Configuration, LogLevel, AzureCloudInstance } from "@azure/msal-browser";
import { Configuration } from "@azure/msal-browser";
export const msalConfig: Configuration = {
auth: {
    clientId: "fe98bb0c-4349-40ea-b4a2-0504e6575486",
    authority: "https://login.microsoftonline.com/64f545cf-42ef-4d14-8973-2f8b87f8c297",
    knownAuthorities: ["login.microsoftonline.com"],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const dataverseScopes = [
  "https://orgde5cf563.crm9.dynamics.com/user_impersonation"
];

export const sharepointScopes = [
  "https://terrenospr.sharepoint.com/AllSites.Read"
];